export default {
  RegisterExperience: {
    RegisterExperience: 'Đăng ký trải nghiệm',
    OrganizationInfo: 'Thông tin đơn vị',
    ContactInfo: 'Thông tin liên hệ',
    RegisterExperienceSuccess: 'Đăng ký trải nghiệm thành công!',
    SubtitleRegisterExperienceSuccess: 'MISA đã nhận được đăng ký của bạn. Vui lòng chờ nhân viên tư vấn liên hệ.'
  }
}
